import {PersonalInfoStepValues} from './types';

export const formatRecipientShortName = (values: PersonalInfoStepValues): string => {
	const firstName = values.firstName.trim();
	const lastInitial = values.secondName.trim().charAt(0);

	if (firstName && lastInitial) {
		return `${firstName} ${lastInitial}.`;
	}

	return [values.secondName, values.firstName].filter((part) => part.trim()).join(' ').trim();
};

export const formatRecipientFullName = (values: PersonalInfoStepValues): string => {
	return [values.secondName, values.firstName, values.patronymic]
		.map((part) => part.trim())
		.filter(Boolean)
		.join(' ');
};
